import React, { FC } from "react";
import SeleccionAsignaturaGIF from "../img/Seleccion_asignatura.gif";
import SeleccionGradoGIF from "../img/Seleccion_grado.gif";
import AsignaturaNivelVideo from "../img/Seleccion_objetivos.gif";
import {
  Modal,
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Estilos para el Modal de ayuda
const styleModalHelp = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "80%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  overflow: "auto",
};

interface Props {
  open: boolean;
  onClose: () => void;
}

const ObjetivesHelp: FC<Props> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModalHelp}>
        <Button
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </Button>
        <Typography
          id="modal-modal-title"
          variant="h4"
          component="h2"
          marginBottom={5}
          sx={{ textAlign: "center", fontFamily: "Inter", fontWeight: "Bold" }}
        >
          Cómo utilizar la sección de Objetivos de Aprendizaje
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <img
              src={SeleccionGradoGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              Selección de grado
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                En el nivel debes seleccionar el grado/nivel para el cual va
                dirigido el proyecto. Por ejemplo:
              </FormLabel>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                • 3ero básico.
              </FormLabel>
            </ul>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              Selección de asignatura
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                En asignatura debes seleccionar las asignaturas que componen el
                proyecto. Por ejemplo:
              </FormLabel>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                • Historia.
              </FormLabel>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                • Lenguaje y arte.
              </FormLabel>
            </ul>
          </Grid>
          <Grid item xs={12} md={6}>
            <img
              src={SeleccionAsignaturaGIF}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ textAlign: "center", fontFamily: "Robot Slab" }}
            >
              Selección de Objetivos
            </Typography>
            <ul>
              <FormLabel
                component="p"
                sx={{ fontFamily: "Inter", m: 0, pb: 2 }}
              >
                Cada vez que selecciones una asignatura, se desplegarán los
                objetivos basales correspondientes a esta. Lee los objetivos de
                aprendizaje listados y utiliza los botones "Agregar" o
                "Eliminar" para incluirlos o removerlos de tu planificación.
              </FormLabel>
            </ul>
          </Grid>
          <Grid item xs={12}>
            <img
              src={AsignaturaNivelVideo}
              alt="Ejemplo"
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                objectFit: "contain",
              }}
            />
          </Grid>
          <ul>
            <FormLabel component="p" sx={{ fontFamily: "Inter", m: 0, pt: 2 }}>
              Para remover una asignatura seleccionada, haz clic en el icono de
              'X' junto a su nombre en el área "Materias seleccionadas". La
              asignatura se eliminará al instante y tu selección de objetivos se
              actualizará automáticamente.
            </FormLabel>
          </ul>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ObjetivesHelp;
